export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7450.30622e8a.jpg";